import React from "react"
import {NoSearchText} from "../../components"

type NoRecentSearchesProps = {
    noSearchesCompleted: string
}

const StandardRecentSearches = ({noSearchesCompleted}: NoRecentSearchesProps) => {
    return <NoSearchText variant="body1">{noSearchesCompleted}</NoSearchText>
}

export default StandardRecentSearches
